import { useTranslation } from "react-i18next";
import WPTertiaryButton from "../packages/WPTertiaryButton";
import { DownloadIcon } from "../assets/icons";

import "./index.scss";

const XLSFileDownload = () => {
  const { t, i18n } = useTranslation();
  const language = i18n.language.includes("en") ? "en-US" : i18n.language;
  const path = window.location.hostname.includes("localhost")
    ? `assets/Cleaning_Template_${language}.xlsx`
    : `assets/Cleaning_Template_${language}.xlsx`;

  // useEffect(() => {
  //   // Your file reading logic here
  //   const fetchDataFromFile = async () => {
  //     try {

  //       const response = await fetch(path);
  //       const data = await response.arrayBuffer();
  //       const workbook = XLSX.read(data, { type: "array" });
  //       const sheetName = workbook.SheetNames[0];
  //       const sheet = workbook.Sheets[sheetName];
  //       const sheetData = XLSX.utils.sheet_to_json(sheet, {
  //         header: 1,
  //         raw: false,
  //       });

  //       // Dispatch an action to store the data in Redux (if using Redux)

  //       dispatch({ type: "STORE_XLS_DATA", payload: sheetData[0] });
  //     } catch (error) {
  //       console.error("Error reading the file:", error);
  //     }
  //   };

  //   fetchDataFromFile();
  // }, []); // Include dependencies as needed

  const downloadXLSX = () => {
    const fileName = `${t(`excelSheetNames.cleaningTemplate`)}.xlsx`;
    // Create a link element to trigger the download
    const a = document.createElement("a");
    a.href = path;
    a.download = fileName;

    // Trigger a click event on the link to start the download
    a.click();
  };

  return (
    <WPTertiaryButton
      onClick={downloadXLSX}
      icon={<DownloadIcon />}
      label={t("ValueStrings.downloadTemplate")}
      className="download-button"
    />
  );
};

export default XLSFileDownload;
